import appRoles from "config/appRoles";

export const SIDEBAR_ITEMS = [
  {
    label: "File split",
    route: "file-split",
    allowedAppRoles: appRoles.IsFileSplitReader,
  },
  {
    label: "Move files",
    route: "move-files",
    allowedAppRoles: appRoles.IsFileMoverReader,
  },
  {
    label: "Data profiling",
    route: "data-profiling",
    allowedAppRoles: appRoles.IsFileSplitReader,
  },
  {
    label: "Config",
    route: "config",
    allowedAppRoles: appRoles.IsConfigReader,
  },
  {
    label: "File masks",
    route: "file-masks",
    allowedAppRoles: appRoles.IsFileSetupReader,
  },
  {
    label: "File mappings",
    route: "file-mappings",
    allowedAppRoles: appRoles.IsFileSetupReader,
  },
  {
    label: "FAO Builder",
    route: "fao-builder",
    allowedAppRoles: appRoles.IsFaoBuilderReader,
    subnav: [
      {
        label: "New Model",
        route: "fao-builder/create",
        icon: "DatabaseAdd",
      },
      {
        label: "Existing Models",
        route: "fao-builder/fao-view",
        icon: "DatabaseSettings",
      },
      {
        label: "Published Models",
        route: "fao-builder/fao-edit",
        icon: "Database",
      },
    ],
  },
  {
    label: "List plus",
    route: "list-plus",
    allowedAppRoles: appRoles.IsListPlusReader,
    subnav: [
      {
        label: "List Uploads",
        route: "list-plus/list-uploads",
        icon: "UploadBatch",
      },
    ],
  },
];
